import React from "react";
import { useTranslation } from "react-i18next";

const CARDS = [
  {
    numKey: "trade.execution.c1.num",
    titleKey: "trade.execution.c1.title",
    descKey: "trade.execution.c1.desc",
    bg: "bg-[#ffe6dc]",
    numColor: "text-[#ccc]",
    dotBg: "bg-[#f04e0a]",
    titleColor: "text-[#0a0a0a]",
    descColor: "text-[#717171]",
    lineColor: "bg-[#ccc]",
  },
  {
    numKey: "trade.execution.c2.num",
    titleKey: "trade.execution.c2.title",
    descKey: "trade.execution.c2.desc",
    bg: "bg-[#0a0a0a]",
    numColor: "text-[#444]",
    dotBg: "bg-[#f04e0a]",
    titleColor: "text-white",
    descColor: "text-[#717171]",
    lineColor: "bg-[#333]",
  },
  {
    numKey: "trade.execution.c3.num",
    titleKey: "trade.execution.c3.title",
    descKey: "trade.execution.c3.desc",
    bg: "bg-[#f04e0a]",
    numColor: "text-[#f7a684]",
    dotBg: "bg-white",
    titleColor: "text-white",
    descColor: "text-[#ffb698]",
    lineColor: "bg-[rgba(255,255,255,0.3)]",
  },
];

function Execution() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[60px]">

        {/* Header */}
        <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-[20px] xl:gap-[60px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[504px]">
            {t("trade.execution.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[600px]">
            {t("trade.execution.desc")}
          </p>
        </div>

        {/* Cards */}
        <div className="flex flex-col xl:flex-row gap-[12px] xl:gap-[20px]">
          {CARDS.map((card, i) => (
            <div key={i} className={`${card.bg} flex flex-col rounded-[20px] p-[30px_28px_36px_30px] xl:p-[30px_28px_51px_30px] min-h-[236px] xl:min-h-[319px] xl:flex-1`}>
              {/* Top row: num + dot */}
              <div className="flex items-center justify-between">
                <span className={`font-['Montserrat'] font-bold text-[13px] tracking-[1.3px] ${card.numColor}`}>
                  {t(card.numKey)}
                </span>
                <div className={`${card.dotBg} w-[14px] h-[14px] rounded-[7px]`} />
              </div>
              {/* Bottom: title + line + desc */}
              <div className="flex flex-col gap-[20px] mt-[40px] xl:mt-[80px]">
                <h3 className={`font-['Montserrat'] font-black text-[20px] xl:text-[24px] ${card.titleColor} tracking-[-0.76px] uppercase leading-[1.2] break-words hyphens-auto`}>
                  {t(card.titleKey)}
                </h3>
                <div className={`h-[1px] ${card.lineColor}`} />
                <p className={`font-['Inter'] font-normal text-[14px] xl:text-[16px] ${card.descColor} leading-[1.4]`}>
                  {t(card.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Execution;
